export enum Outcome {
  ELIGIBLE = 'ELIGIBLE',

  /** Eligible, but the remaining limit is below the requested amount. */
  LIMITED = 'LIMITED',

  /** The coverage or asset rules exclude this job. */
  EXCLUDED = 'EXCLUDED',

  /** The loss falls outside the contract: dates, usage limit, cancellation, status or waiting period. */
  INELIGIBLE = 'INELIGIBLE',

  /** A date, asset value or usage reading is missing, so no rule can decide yet. */
  INSUFFICIENT_INFORMATION = 'INSUFFICIENT_INFORMATION',
}

/** The checks, in the order they decide the outcome. */
export enum Step {
  DATES = 'DATES',
  TERM_WINDOW = 'TERM_WINDOW',
  USAGE = 'USAGE',
  STATUS = 'STATUS',
  WAITING_PERIOD = 'WAITING_PERIOD',
  COVERAGE = 'COVERAGE',
  ASSET = 'ASSET',
  LIMITS = 'LIMITS',
}

export const STEP_ORDER: Step[] = [
  Step.DATES,
  Step.TERM_WINDOW,
  Step.USAGE,
  Step.STATUS,
  Step.WAITING_PERIOD,
  Step.COVERAGE,
  Step.ASSET,
  Step.LIMITS,
];

// Inside one step, a definite answer from present values beats "missing information".
export const OUTCOME_RANK: Outcome[] = [
  Outcome.INELIGIBLE,
  Outcome.EXCLUDED,
  Outcome.INSUFFICIENT_INFORMATION,
  Outcome.LIMITED,
  Outcome.ELIGIBLE,
];

export enum Code {
  LOSS_DATE_MISSING = 'LOSS_DATE_MISSING',
  LOSS_DATE_INVALID = 'LOSS_DATE_INVALID',
  CLAIM_DATE_INVALID = 'CLAIM_DATE_INVALID',
  LOSS_AFTER_CLAIM_DATE = 'LOSS_AFTER_CLAIM_DATE',

  LOSS_BEFORE_TERM_START = 'LOSS_BEFORE_TERM_START',
  LOSS_AFTER_EXPIRY = 'LOSS_AFTER_EXPIRY',

  LOSS_AFTER_CANCELLATION = 'LOSS_AFTER_CANCELLATION',
  WARRANTY_DRAFT = 'WARRANTY_DRAFT',
  WARRANTY_VOID = 'WARRANTY_VOID',
  WARRANTY_FROZEN = 'WARRANTY_FROZEN',

  LOSS_IN_WAITING_PERIOD = 'LOSS_IN_WAITING_PERIOD',

  COVERAGE_MISSING = 'COVERAGE_MISSING',
  COVERAGE_NOT_ON_WARRANTY = 'COVERAGE_NOT_ON_WARRANTY',
  COVERAGE_NOT_IN_PLAN = 'COVERAGE_NOT_IN_PLAN',
  COVERAGE_NOT_APPLICABLE = 'COVERAGE_NOT_APPLICABLE',
  COVERAGE_ENDED = 'COVERAGE_ENDED',
  COVERAGE_VALUE_MISSING = 'COVERAGE_VALUE_MISSING',

  ASSET_SUBMISSION_MISSING = 'ASSET_SUBMISSION_MISSING',
  ASSET_SET_MISMATCH = 'ASSET_SET_MISMATCH',
  ASSET_VALUE_MISSING = 'ASSET_VALUE_MISSING',
  PLAN_CONDITION_FAILED = 'PLAN_CONDITION_FAILED',
  TERM_CONDITION_FAILED = 'TERM_CONDITION_FAILED',

  USAGE_READING_MISSING = 'USAGE_READING_MISSING',
  USAGE_SALE_READING_MISSING = 'USAGE_SALE_READING_MISSING',
  USAGE_READING_BELOW_SALE = 'USAGE_READING_BELOW_SALE',
  USAGE_RENEWED_UNMEASURED = 'USAGE_RENEWED_UNMEASURED',
  USAGE_LIMIT_UNDECIDED = 'USAGE_LIMIT_UNDECIDED',
  USAGE_LIMIT_EXCEEDED = 'USAGE_LIMIT_EXCEEDED',

  LIMIT_BELOW_REQUESTED = 'LIMIT_BELOW_REQUESTED',
}

/** Version of the evaluator's own logic; bump it when a rule's meaning changes. */
export const RULES_VERSION = 1;

/** Calendar dates are compared in this zone until the product sets one. */
export const DEFAULT_TIME_ZONE = 'UTC';
